import { Fragment } from 'react';
import { Flex } from '../Flex/index.js';
import { Text } from '../Text/index.js';
import { BADGE_VARIANT } from './constants.js';
import { BaseBadge } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const Badge = ({
  children,
  icon,
  iconPosition = 'left',
  size = 'md',
  status = 'info',
  variant = 'label',
  ...props
}) => {
  const isSingleCounterDigit = typeof children === 'string' && children.length === 1;
  const content = () => jsxs(Fragment, {
    children: [icon && iconPosition === 'left' && jsx(Flex, {
      as: "span",
      mr: 0.5,
      children: icon
    }), jsx(Text.Body, {
      as: "strong",
      bold: true,
      lineHeight: "16px",
      size: "xs",
      children: children
    }), icon && iconPosition === 'right' && jsx(Flex, {
      as: "span",
      ml: 0.5,
      children: icon
    })]
  });
  return jsx(BaseBadge, {
    isSingleCounterDigit: isSingleCounterDigit,
    size: size,
    status: status,
    variant: variant,
    ...props,
    children: variant !== BADGE_VARIANT.pip && content()
  });
};

export { Badge };
